// eslint-disable-next-line import/prefer-default-export
export const GetDonorsSelector = ({ donors: { GetDonors } }) => GetDonors;

export const PostDonorsSelector = ({ donors: { PostDonors } }) => PostDonors;
